import React from "react";
const classes = require('./Social.module.scss');

const social = (props) => {
  return (
    <ul className={[classes.Social, classes[props.where]].join(' ')}>
      <li><a href="https://www.facebook.com/Marker158dockside" target="_blank" rel="noopener noreferrer">
        <span className={classes.SocialIcon} aria-label="Mile Marker 158 Dockside Facebook Link" uk-icon="icon: facebook"></span>
      </a></li>

      <li><a href="https://www.instagram.com/milemarker158" target="_blank" rel="noopener noreferrer">
        <span aria-label="Mile Marker 158 Dockside Instagram Link" uk-icon="icon: instagram"></span>
      </a></li>

      <li><a href="https://twitter.com/MileMarker158" target="_blank" rel="noopener noreferrer">
        <span aria-label="Mile Marker 158 Dockside Twitter Link" uk-icon="icon: twitter"></span>
      </a></li>
    </ul>
  );
};

export default social;
